
import SidebarEstande from '../../../Layouts/SidebarEstandes';
import TelaMapaFeira from '../../../pages/Vendas/TelaMapaFeira';
import TopoMapas2 from '../../../Components/Common/Banner';

const Desktop = () => {
  return (
    <div className={`modulo-vendas-container`}>
      <div className="app-frame">
        <TopoMapas2/>
        <div className="layout">
          <SidebarEstande />
          <TelaMapaFeira />
        </div>
      </div>
  </div>
  );
};

export default Desktop;